import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';

type ReportsPageEntryPointComponent = EntryPointComponent<{}, {}, {}, {} | null>;

export const reportsTypePageEntryPoint: EntryPoint<ReportsPageEntryPointComponent, {}> = {
	root: JSResourceForUserVisible<ReportsPageEntryPointComponent>(
		/* webpackChunkName: "async-csm-reports-type-entrypoint" */ './ServicedeskReportsPage.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({}),
};
